<script>
    import "./styles/App.css";
    import Home from "./Home.svelte";
    import About from "./About.svelte";
    import OfficersPage from "./OfficersPage.svelte";
    import Workshop from "./Workshop.svelte";
    import Calendar from "./Calendar.svelte";
    import Alumni from "./Alumni.svelte";

    let currentPage = "home";

    function navigate(page) {
        currentPage = page;
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    function handleEventClick() {
        currentPage = "workshop"; // Change to Workshop page
    }

    let eggRevealed = false;

    function handleEasterEggReveal() {
        eggRevealed = true;
    }
</script>

<nav>
    <div class="logo">
        <img
            src="/assets/logo4.1.svg"
            alt="ACM Logo"
            class="logo"
            on:click={() => navigate("home")}
        />
    </div>
    <div style="justify-content: center;">
        <button class="button" on:click={() => navigate("home")}>Home</button>
        <button class="button" on:click={() => navigate("about")}>About</button>
        <button class="button" on:click={() => navigate("officers")}
            >Leadership</button
        >
        <button class="button" on:click={() => navigate("workshop")}
            >Workshops</button
        >
        <button class="button" on:click={() => navigate("alumni")}
            >Alumni</button
        >
    </div>
</nav>

<div class="content">
    {#if currentPage === "home"}
        <Home {handleEventClick} {navigate} />
    {:else if currentPage === "about"}
        <About />
    {:else if currentPage === "cal"}
        <Calendar />
    {:else if currentPage === "workshop"}
        <Workshop shouldScroll={true} />
    {:else if currentPage === "officers"}
        <OfficersPage />
    {:else if currentPage === "alumni"}
        <Alumni />
    {/if}
</div>

<footer>
    <p>
        &copy; {new Date().getFullYear()} ACM UMD Chapter
            {#if !eggRevealed}
                <button
                    class="easter-egg-button"
                    on:click={handleEasterEggReveal}
                >
                O&#95;o
                </button>
            {:else}
                <span class="easter-egg-reveal">
                    🥚 You found an Easter egg! More are hidden — JZ!
                </span>
            {/if}
    </p>
    <div class="inner">
        <a
            href="https://discord.com/invite/4HkYzUpN67"
            target="_blank"
            class="icon-container"
        >
            <img
                src="/assets/icons/discord-white-icon.svg"
                alt="Discord Icon"
                class="icon"
            />
        </a>
        <a
            href="https://github.com/acm-umd"
            target="_blank"
            class="icon-container"
        >
            <img
                src="/assets/icons/github-mark-white.svg"
                alt="GitHub Icon"
                class="icon"
            />
        </a>
        <a
            href="https://www.reddit.com/user/ACM_UMD/"
            target="_blank"
            class="icon-container"
        >
            <img
                src="/assets/icons/reddit-icon-white.svg"
                alt="Reddit Icon"
                class="icon"
            />
        </a>
    </div>
    <div class="inner">
        <a
            href="https://www.instagram.com/acm.umd/"
            target="_blank"
            class="icon-container"
        >
            <img
                src="/assets/icons/instagram-white-icon.svg"
                alt="Insta Icon"
                class="icon"
            />
        </a>
        <a
            href="https://www.linkedin.com/groups/12988736/"
            target="_blank"
            class="icon-container"
        >
            <img
                src="/assets/icons/linkedin-icon-white.svg"
                alt="Linkedin Icon"
                class="icon"
            />
        </a>
        <a
            href="https://terplink.umd.edu/organization/acm"
            target="_blank"
            class="icon-container"
        >
            <img
                src="/assets/icons/terplink-logo.svg"
                alt="Terplink Icon"
                class="icon-terplink"
            />
        </a>
    </div>
</footer>

<style>
    @keyframes slideInRight {
        0% {
            transform: translateX(100%);
            opacity: 0;
        }
        100% {
            transform: translateX(0);
            opacity: 1;
        }
    }

    @keyframes slideInLeft {
        0% {
            transform: translateX(-100%);
            opacity: 0;
        }
        100% {
            transform: translateX(0);
            opacity: 1;
        }
    }

    :global(body) {
        display: flex;
        flex-direction: column; /* Arrange children in a column */
        min-height: 100vh; /* Full viewport height */
        margin: 0; /* Remove default margin */
        background-color: #333333;
        background-image: url("/assets/backgroundlineart.jpg");
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
    }

    .logo {
        display: flex;
        align-items: center; /* Vertically centers the logo-text */
        justify-content: left; /* Optionally center the content horizontally */
        animation: slideInLeft 1.5s ease forwards;
    }

    .icon {
        max-width: 40px; /* Adjust the icon size */
        max-height: 40px;
        height: auto; /* Maintain aspect ratio */
    }
    .icon-terplink {
        max-width: 40px; /* Adjust the icon size */
        max-height: 40px;
        height: auto; /* Maintain aspect ratio */
    }

    .button {
        animation: slideInRight 1.5s ease forwards;
        margin-left: 2vw;
        cursor: pointer;
        text-decoration: none;
        color: #ff4433;
        background: none;
        border: none;
        font-size: 2vw;
        outline: none;
        font-family: "Quicksand", sans-serif;
    }

    .button:hover {
        text-decoration: underline;
    }

    .button:focus {
        background: none;
        outline: none;
    }

    .content {
        flex: 1; /* Allow the content area to grow and take available space */
    }
    footer a {
        color: #ffd520; /* Footer link color */
    }

    .easter-egg-button {
        padding: 0.3rem 0.6rem;
        border: none;
        border-radius: 6px;
        background-color: transparent;
        color: rgba(255, 255, 255, 0.8);
        font-size: 0.8rem;
        font-weight: normal;
        cursor: pointer;
        transition: all 0.2s ease;
        box-shadow: none;
        opacity: 0.3;
    }

    .easter-egg-button:hover {
        color: #ffd520;
        opacity: 0.7;
        transform: scale(1.05);
        background-color: rgba(255, 255, 255, 0.05);
    }

    .easter-egg-reveal {
        font-size: 0.9rem;
        color: #fff;
        background: rgba(255, 255, 255, 0.15);
        padding: 0.5rem;
        border-radius: 6px;
        display: inline-block;
        animation: popIn 0.4s ease;
    }

    @keyframes popIn {
        from {
            transform: scale(0.8);
            opacity: 0;
        }
        to {
            transform: scale(1);
            opacity: 1;
        }
    }

    @media only screen and (max-width: 600px) {
        :global(body) {
            overflow-x: hidden;
        }
        .icon {
            max-width: 40px; /* Adjust the icon size */
            max-height: 40px;
            height: auto; /* Maintain aspect ratio */
        }
        .icon-terplink {
            max-width: 7vw; /* Adjust the icon size */
            height: auto; /* Maintain aspect ratio */
        }
        .icon-container {
            height: 40px;
            width: 40px;
            display: flex; /* Use flexbox to align items */
            align-items: center; /* Center items vertically */
            justify-content: center; /* Optional: center items horizontally */
        }
        .button {
            animation: slideInRight 1.5s ease forwards;
            margin-left: 2vw;
            cursor: pointer;
            text-decoration: none;
            color: #ff4433;
            background: none;
            border: none;
            font-size: 3vw;
            outline: none;
            font-family: "Quicksand", sans-serif;
        }
        .button:focus {
            background: none;
            outline: none;
        }
        .inner {
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
</style>
